import {Component, Vue} from 'vue-property-decorator';
import {AllFilterDateMapping, GetCustomPropertiesValues} from '@/types/customProperty';
import {ProductsSearch} from 'supporter';

import {changeDateFormat} from '@/utils/dateUtils';
import { convertProductUri, escapeHtml } from '@/utils/commonUtils';

@Component
export default class CustomPropertyDataMixin extends Vue {
  public today: string = changeDateFormat('', 'YYYY-MM-DD HH:mm:ss');

  public productContents: ProductsSearch = {
    contents: [],
    totalPage: 0,
    totalCount: 0
  };

  public customPropertySummaries: GetCustomPropertiesValues = {
    usable: false,
    propertyName: '',
    propertyValueLabel: '',
    multiSelectionEnabled: true,
    propertyValueNo: 0
  };

  public searchParams = {
    page: 1,
    size: 15
  };

  public getGridLayouts: any = [];

  public productDetailUrlObj: {[propName: string]: string} = {};
  public getProductDetailUrl({value, row}: any): string {
    const uri = convertProductUri(this.productDetailUrlObj[row.mallNo + ''], value)
    return `<a target="_blank" href="${uri}">${value}</a>`;
  }

  public defaultDisplayOrder = [
    {
      header: this.$t('PRODUCT_CUSTOM_PROPERTY_MALL_NAME'),
      name: 'mallName',
      order: 1,
      displayName: this.$t('PRODUCT_CUSTOM_PROPERTY_MALL_NAME'),
      minWidth: 61,
      align: 'center'
    },
    {
      header: this.$t('PRODUCT_CUSTOM_PROPERTY_MALL_PRODUCT_NO'),
      name: 'mallProductNo',
      order: 2,
      displayName: this.$t('PRODUCT_CUSTOM_PROPERTY_MALL_PRODUCT_NO'),
      formatter: this.getProductDetailUrl,
      minWidth: 121,
      align: 'center'
    },
    {
      header: this.$t('PRODUCT_CUSTOM_PROPERTY_PRODUCT_NAME'),
      name: 'productName',
      order: 3,
      displayName: this.$t('PRODUCT_CUSTOM_PROPERTY_PRODUCT_NAME'),
      minWidth: 231,
      formatter: ({value})=>escapeHtml(value),
    },
    {
      header: this.$t('PRODUCT_CUSTOM_PROPERTY_ADMIT_STATUS'),
      name: 'applyStatusType',
      order: 4,
      displayName: this.$t('PRODUCT_CUSTOM_PROPERTY_ADMIT_STATUS'),
      minWidth: 81,
      align: 'center',
      formatter: ({row}: any): any => {
        let text = '';
        switch (row.applyStatusType) {
          case 'REGISTRATION_READY':
            text = '등록대기';
            break;
          case 'APPROVAL_READY':
            text = '승인대기';
            break;
          case 'APPROVAL_REJECTION':
            text = '승인거부';
            break;
          case 'SALE_AGREEMENT_READY':
            text = '판매합의대기';
            break;
          case 'SALE_AGREEMENT_REJECTION':
            text = '판매합의거부';
            break;
          case 'AFTER_APPROVAL_READY':
            text = '수정 후 승인대기';
            break;
          case 'AFTER_APPROVAL_REJECTION':
            text = '수정 후 승인거부';
            break;
          default:
            return '승인완료';
            break;
        }
        return text;
      }, 
      copyOptions: {
          useFormattedValue: true,
      }
      
    },
    {
      header: this.$t('PRODUCT_CUSTOM_PROPERTY_SALE_STATUS'),
      name: 'saleStatusType',
      order: 5,
      displayName: this.$t('PRODUCT_CUSTOM_PROPERTY_SALE_STATUS'),
      minWidth: 81,
      align: 'center',
      formatter: ({row}: any): any => {
        let text;
        switch (row.saleStatusType) {
          case 'WAITING_SALE': // 판매대기
            text = this.$t('PRODUCT_CUSTOM_PROPERTY_WAITING_SALE');
            break;
          case 'ON_SALE': // 판매중
            text = this.$t('PRODUCT_CUSTOM_PROPERTY_ON_SALE');
            break;
          case 'END_SALE': // 판매종료
            text = this.$t('PRODUCT_CUSTOM_PROPERTY_END_SALE');
            break;
          case 'ON_PRE_SALE': // 예약판매중
            text = this.$t('PRODUCT_CUSTOM_PROPERTY_ON_PRE_SALE');
            break;
          case 'PRE_APPROVAL_STATUS': // 승인완료이전
          default:
            text = '-';
            break;
        }
        return text;
      }, 
      copyOptions: {
          useFormattedValue: true,
      }
    },
    {
      header: this.$t('PRODUCT_CUSTOM_PROPERTY_SALE_SETTING_STATUS'),
      name: 'saleSettingStatusType',
      order: 6,
      displayName: this.$t('PRODUCT_CUSTOM_PROPERTY_SALE_SETTING_STATUS'),
      minWidth: 81,
      align: 'center',
      formatter: ({row}: any): any => {
        let text;
        switch (row.saleSettingStatusType) {
          case 'AVAILABLE_FOR_SALE': // 판매가능
            text = this.$t('PRODUCT_CUSTOM_PROPERTY_AVAILABLE_FOR_SALE');
            break;
          case 'STOP_SELLING': // 판매중지
            text = this.$t('PRODUCT_CUSTOM_PROPERTY_STOP_SELLING');
            break;
          case 'PROHIBITION_SALE': // 판매금지
            text = this.$t('PRODUCT_CUSTOM_PROPERTY_PROHIBITION_SALE');
            break;
          default:
            text = '-';
            break;
        }
        return text;
      }, 
      copyOptions: {
          useFormattedValue: true,
      }
    },
    {
      header: this.$t('PRODUCT_CUSTOM_PROPERTY_SALE_PERIOD'),
      name: 'saleDateTime',
      order: 7,
      visible: true,
      displayName: this.$t('PRODUCT_CUSTOM_PROPERTY_SALE_PERIOD'),
      minWidth: 285,
      align: 'center'
    }
  ];

  public gridProps? = {
    columns: [],
    pageOptions: {
      page: 1,
      totalCount: 0,
      perPage: 30
    }
  };

  public gridOptions?: {[propName: string]: any} = {
    id: 'tui-grid-customProperty',
    columnOptions: {
      minWidth: 70,
      resizable: true
    },
    bodyHeight: 400,
    rowHeight: 31,
    minRowHeight: 35,
    isInitialRequest: true,
    useClientSort: false,
    heightResizable: true
  };

  public filterDateMapping: AllFilterDateMapping = {
    '0': [0, 'd'],
    '1w': [-7, 'd'],
    '1m': [-1, 'M'],
    '3m': [-3, 'M'],
    '6m': [-6, 'M'],
    '1y': [-1, 'y'],
    ALL: [100, '']
  };
}
